import { ReactElement } from 'react';
import { UIText } from '../ui-text';
import styles from './ui-segmented-control.module.scss';

type UISegmentedControlProps = {
    items: UISegmentedControlItemProps[];
    selectedIndex: number;
    selectedIndexChanged: (index: number) => void;
};

export function UISegmentedControl(
    props: UISegmentedControlProps
): ReactElement {
    const { items, selectedIndex, selectedIndexChanged } = props;

    return (
        <div className={styles.container}>
            {items.map((itemProps, index) => (
                <UISegmentedControlItem
                    key={index}
                    {...itemProps}
                    isSelected={selectedIndex == index}
                    onClick={() => selectedIndexChanged(index)}
                />
            ))}
        </div>
    );
}

type UISegmentedControlItemProps = {
    text: string;
    /** When true, the item is shown greyed out and cannot be selected. */
    disabled?: boolean;
};

function UISegmentedControlItem(
    props: UISegmentedControlItemProps & {
        isSelected: boolean;
        onClick: () => void;
    }
): ReactElement {
    const { text, disabled = false, isSelected, onClick } = props;
    return (
        <div
            className={`${styles.itemContainer} ${isSelected ? styles.selected : ''} ${disabled ? styles.disabled : ''}`}
        >
            <button
                className={styles.item}
                disabled={disabled}
                onClick={onClick}
            >
                <UIText
                    type={
                        disabled ? 'disabled' : isSelected ? 'link' : 'default'
                    }
                >
                    {text}
                </UIText>
            </button>
        </div>
    );
}
